import vue from "vue";
import vuex from "vuex";
import os from "os";
// import { remote } from "electron";

vue.use(vuex);

export interface Tip {
	text: string;
	left: number;
	top: number;
	show: boolean;
}

const book = localStorage.getItem("accountBook");

const isOper = (payload: any) => {
	if (payload.accountBookInfo) {
		if (payload.taxFormDto.taxInfoMap["生产经营所得税"].id !== null) {
			return true;
		} else {
			if (payload.accountBookInfo.companyType) {
				if (payload.accountBookInfo.companyType.includes("个人独资") || payload.accountBookInfo.companyType.includes("有限合伙") || payload.accountBookInfo.companyType.includes("普通合伙") || payload.accountBookInfo.companyType.includes("个体工商户")) {
					return true;
				} else return false;
			}
		}
	}
	return false;
}

const store = new vuex.Store({
	state: {
		account: {
			id: localStorage.getItem("id") || "",
			login: true,
			loginId: localStorage.getItem("loginId") || "",
			hashPassword: "",
			name: localStorage.getItem("name") || "",
			no: localStorage.getItem("no") || "",
			token: localStorage.getItem("token") || "",
			role: localStorage.getItem("role") || "",
			level: localStorage.getItem("level") || "",
			freeDays: localStorage.getItem("freeDays") || ""
		},
		// 账套备注
		accountRemark: [],
		currentLinks: [],
		currentIcon: "记账",
		// 征期
		collectPeriod: new Date(),
		today: new Date().getDate(),
		collectMessage: "",

		// 进入账套后的账套信息
		accountBook: book ? JSON.parse(book) : {
			id: null,
			bookName: ""
		},
		// 更新视图val
		updateState: {
			visble: false,
			percent: 0
		},

		// 下载视图val
		downloadState: {
			visble: false,
			percent: 0
		},

		searchKey: "",

		tip: {
			text: "",
			left: 0,
			top: 0,
			show: false
		},

		printers: <Electron.PrinterInfo[]>[],

		// 使用备用服务器
		useBackup: false,
		// 缩放比例,
		zoomValue: localStorage.getItem("zoomValue") ? localStorage.getItem("zoomValue") : 1,
		sheet: {
			top: 45,
			left: 30,
			right: 30,
		},
		voucherPrint: {
			top: 45,
			left: 30,
			right: 30,
		},
		// 前进后退的position
		historyLength: 0,
		currentPos: 0,
		// 用户当前屏幕的宽度
		windowWidth: 1080,

		// 凭证行数
		voucherRows: localStorage.getItem("voucherRows") !== null ? +(<string>localStorage.getItem("voucherRows")) : 6,

		// 系统
		os: os.platform(),
		// 环境
		env: process.env.VUE_APP_TITLE,

		// tab 列表，默认有1个
		tabs: [
			{ url: "/", name: "主页" }
		],
		// 
		isOper: book ? isOper(JSON.parse(book)) : false,
		currentTab: 0,
		navList: () => {
			let isJzs = process.env.VUE_APP_TITLE === "jzs";
			let list = [
				{
					title: "收费",
					icon: "收费",
					scale: 4,
					message: [
						{ url: "/charge", name: "记账收费" },
						{ url: "/debitNote", name: "收费对账" }
					]
				},
				{
					title: "记账",
					icon: "客户",
					scale: 4,
					message: [
						{ url: "/accountbooklist", name: "客户列表" },
						{ url: "/dashboard", name: "进度监测" },
						{ url: "/multi", name: "批量操作" }
					]
				},
				{
					title: "报税",
					icon: "报税",
					scale: 4,
					message: [
						{ url: "/taxdeclaration", name: "批量报税" },
						{ url: "/taxtask", name: "报税任务" },
						{ url: "/taxentry", name: "报税录入" },
						{ url: "/taxlist", name: "报税列表" }
					]
				},
				{
					title: "管理",
					icon: "公司",
					scale: 4,
					message: [
						{ url: "/user", name: "人员组织" },
						{ url: "/performance", name: "员工绩效" },
						{ url: "/managementanalysis", name: "经营分析" },
					    isJzs ? { url: "/integral", name: "会员积分" } : null,
						{ url: "/messagecode", name: "短信列表" },
						store.state.account.role.includes("超级管理员") ? { url: "/systemtool", name: "系统工具" } : null,
						store.state.account.role.includes("管理员") ? { url: "/logrecord", name: "系统日志" } : null
					]
				},
				{
					title: "工商",
					icon: "工商",
					scale: 2,
					message: [
						{ url: "/business", name: "工商年报" }
					]
				},
				{
					title: "账套迁移",
					icon: "账套迁移",
					scale: 3.4,
					message: [
						// { url: "/datacollect", name: "数据采集" },
						{ url: "/dataimport", name: "数据导入" }
					]
				},
				{
					title: "智能客服",
					icon: "robot",
					scale: 3.4
				}
			];
			if ((store.state.account.role === "会计" || store.state.account.role === "助理" || store.state.account.role === "主管") && isJzs) {
				list.splice(0, 1);
			}
			return list;
		},
		oneKeyTipVisible: false
	},
	mutations: {},
	actions: {
		login(state, payload: Account) {
			state.state.account.id = payload.id;
			state.state.account.loginId = <string>payload.loginId;
			state.state.account.hashPassword = <string>payload.hashPassword;
			state.state.account.no = payload.no;
			state.state.account.token = <string>payload.token;
			state.state.account.role = <string>payload.role;
			state.state.account.level = <string>payload.level;
			state.state.account.freeDays = <string>payload.freeDays;
			localStorage.setItem("id", <string>payload.id);
			localStorage.setItem("loginId", <string>payload.loginId);
			localStorage.setItem("hashPassword", <string>payload.hashPassword);
			localStorage.setItem("no", payload.no);
			localStorage.setItem("token", <string>payload.token);
			localStorage.setItem("role", <string>payload.role);
			localStorage.setItem("level", <string>payload.level);
			if (payload.name) {
				state.state.account.name = payload.name;
				localStorage.setItem("name", payload.name);
			}
			state.state.account.login = true;
		},
		logout(state) {
			state.state.account = {
				freeDays: "",
				id: "",
				login: false,
				loginId: "",
				hashPassword: "",
				name: "",
				no: "",
				token: "",
				role: "",
				level: ""
			};
		},

		// 全局链接操作
		changeLink(state, payload: App.Menu[]) {
			// @ts-ignore
			state.state.currentLinks = payload;
		},

		// 全局currentIcon更改操作
		changeCurrentIcon(store, payload: string, noClear?: boolean) {
			let list = store.state.navList();
			const n = list.length === 7 ? 0 : -1;

			let icon = payload || "记账";
			switch (payload) {
				case "记账":
					// @ts-ignore
					store.state.currentLinks = list[1 + n].message;
					icon = payload;
					break;
				case "报税":
					// @ts-ignore
					store.state.currentLinks = list[2 + n].message;
					break;
				case "管理":
					// @ts-ignore
					store.state.currentLinks = list[3 + n].message;
					icon = payload;
					break;
				case "账套迁移":
					// @ts-ignore
					store.state.currentLinks = list[4 + n].message;
					break;
				case "收费":
					// @ts-ignore
					store.state.currentLinks = list[0 + n].message;
					icon = payload;
					break;
			}
			store.state.currentIcon = icon;
			// store.dispatch("initAccounBook");
			// if (store.state.accountBook.bookName !== "" && !noClear) {
			// 	store.state.accountBook.bookName = "";
			// 	store.state.historyLength = 0;
			// 	store.state.currentPos = 0;
			// }
		},

		// 全局初始化accounBook
		initAccounBook(state) {
			state.state.accountBook.bookName = "";
			state.state.historyLength = 0;
			state.state.currentPos = 0;
		},
		// 全局更改accountBook
		changeAccounBook(state, payload: AccountBookList.AccountBook) {
			// @ts-ignore
			state.state.accountBook = payload;

			state.state.isOper = isOper(payload);
			localStorage.setItem("accountBook", JSON.stringify(payload));
		},
		// 全局更改账套备注
		changeAccountRemark(state, payload: AccountBookList.AccountRemark[]) {
			// @ts-ignore
			state.state.accountRemark = payload;
		},
		// 全局征期
		updateCollectMessage(state, payload) {
			state.state.today = payload.date;
			state.state.collectMessage = payload.message;
			state.state.collectPeriod = payload.currentPeriod;
		},

		// 设置更新界面显示及下载状态
		toggleUpdate(state, val: boolean) {
			state.state.updateState.visble = val;
		},
		updatePercent(state, val: number) {
			state.state.updateState.percent = val;
		},

		// 设置搜索key
		changeSerchKey(state, val: string) {
			state.state.searchKey = val;
		},
		clearSearchKey(state) {
			state.state.searchKey = "";
		},

		// 设置更新界面显示及下载状态
		toggleDownload(state, val: boolean) {
			state.state.downloadState.visble = val;
		},
		updateDownload(state, val: number) {
			state.state.downloadState.percent = val;
		},

		// 设置全局的tip文字
		setTip(state, val: Tip) {
			state.state.tip = val;
		},

		// 设置当前账套的结账日期
		setClosePeriod(state, val: string) {
			// @ts-ignore
			state.state.accountBook.closePeriod = val;
		},

		// 获取打印机列表
		getPrinters(store, content: Electron.PrinterInfo[]) {
			store.state.printers = content;
		},
		// 结账后更新currentPeriod
		changeCurrentPeriod(store, payload: string) {
			// @ts-ignore
			store.state.accountBook.currentPeriod = payload;
		},
		changeStartPeriod(store, payload: string) {
			// @ts-ignore
			store.state.accountBook.startPeriod = payload;
		},
		// 修改使用备用服务器状态
		toggleBackup(store, payload: boolean) {
			store.state.useBackup = payload;
		},
		// 修改页面缩放比例
		zoomChange(state, payload: number) {
			state.state.zoomValue = payload;
		},
		// 修改表单的边距
		sheetChangeTop(state, payload: number) {
			state.state.sheet.top = payload;
		},
		sheetChangeLeft(state, payload: number) {
			state.state.sheet.left = payload;
		},
		sheetChangeRight(state, payload: number) {
			state.state.sheet.right = payload;
		},
		voucherPrintchange(state, payload: any) {
			state.state.voucherPrint = payload;
		},
		historyChange(store, payload: number) {
			store.state.historyLength = payload;
		},
		currentPosChange(store, payload: number) {
			store.state.currentPos = payload;
		},
		// 获取当前宽度
		widthChange(store, payload: number) {
			store.state.windowWidth = payload;
		},
		// 改变打印的凭证行数
		changeVoucherRow(store, arg: number) {
			store.state.voucherRows = arg;
			localStorage.setItem("voucherRows", arg.toString());
		},
		// 右键单击nav的pop
		openNewTab(store, nav: { url: string; name: string }) {
			store.state.tabs.push(nav);
			store.state.currentTab = store.state.tabs.length - 1;
		},
		contextMenu(store, nav: { url: string; name: string }) {
			store.dispatch("openNewTab", nav);
		}
	}
});

export default store;
